export var GoogleWorkspaceRestoreWorkload;
(function (GoogleWorkspaceRestoreWorkload) {
    GoogleWorkspaceRestoreWorkload["GOOGLE_WORKSPACE_RESTORE_WORKLOAD_ALL"] = "ALL";
    GoogleWorkspaceRestoreWorkload["GOOGLE_WORKSPACE_RESTORE_WORKLOAD_DRIVE"] = "DRIVE";
    GoogleWorkspaceRestoreWorkload["GOOGLE_WORKSPACE_RESTORE_WORKLOAD_GMAIL"] = "GMAIL";
})(GoogleWorkspaceRestoreWorkload || (GoogleWorkspaceRestoreWorkload = {}));
